import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import {
  BehaviorSubject,
  Observable,
  Subscription,
  debounceTime,
  switchMap,
  take,
  tap,
  timer,
  finalize,
  filter,
  map,
} from 'rxjs';
import { Auto_Complete } from 'src/app/core/services/auto-complete';
import { ErrorHandlingService } from 'src/app/core/services/error-handling.service';
import { HttpService } from 'src/app/core/services/api/http.service';
import { ClaimApiService } from '../../../core/services/api/claim-api.service';
import { ApiResponse } from 'src/app/shared/models/api-response.interface';
import { FilterOption, Option } from '../../models/option.interface';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { API_VERSIONS } from '../../consts/api-versions.const';
import { AuthService } from '../../../core/services/auth.service';
import {
  CLAIM_FILTER_OPTIONS,
  CLAIM_FILTER_OPTIONS_FOR_BROKER,
  CLAIM_FILTER_OPTIONS_FOR_DEALER,
  CLAIM_FILTER_OPTIONS_FOR_MANAGEMENT,
} from './claim-filter-options';
import { TableFilterBarComponent } from '../table-filter-bar/table-filter-bar.component';
import { UsersGroup } from '../../enums/users-group.enum';

@UntilDestroy()
@Component({
  selector: 'app-claim-list',
  templateUrl: './claim-list.component.html',
  styleUrls: ['./claim-list.component.css'],
})
export class ClaimListComponent implements OnInit, OnDestroy {
  @ViewChild('tableFilterBar') tableFilterBar!: TableFilterBarComponent;
  @Input() vehicleId?: number;
  @Input() isDealerView?: boolean = false;
  @Input() isBrokerView?: boolean = false;
  @Input() isManagementView?: boolean = false;
  @Input() viewClaimLink?: string;
  @Input() basicParams: Params = {};
  @Input() showPayClaimAction = false;
  @Output() payClaim = new EventEmitter<any>();

  categories = [
    { name: 'VIN Number', key: 'Vin Number' },
    { name: 'Customer Name', key: 'Customer Name' },
    { name: 'Customer Phone', key: 'Customer Phone' },
    { name: 'Customer Address', key: 'Customer Address' },
    { name: 'Contract Number', key: 'Contract Number' },
    { name: 'Claim Number', key: 'Claim Number' },
    { name: 'Product', key: 'Product' },
    // {name:'Claim Adjuster' , key:'6'},
    // {name:'Seller' , key:'7'},
    { name: 'Repair Facility', key: 'Repair Facility' },
    { name: 'Service Advisor', key: 'Service Advisor' },
  ];
  selectCategory: any;
  perPages: any;
  refreshRate: any = 20000;
  mySubscription!: Subscription;
  selectClaimsPerPage: any;
  repeatClaimRow: any = [];
  repeatVehicleRow: any = ['', '', '', '', '', '', '', '', '', '', ''];
  currentPage: number = 1;
  totalItems: number = 0;
  pageSize: number = 10;
  queryParams!: Subscription;
  isMobile: boolean = window.innerWidth < 768 ? true : false;
  isLoading: boolean = false;
  isClaimStatusLoading: boolean = false;
  sorts: any[] = [];
  RepairFacility: any[] = [];
  claimAdjustor: any[] = [];
  createdBy: any[] = [];
  updatedBy: any[] = [];
  dealers: any[] = [];
  brokers: any[] = [];
  agents: any[] = [];

  filterOptions: FilterOption[] = [];
  // search
  public model: any;
  searchInput = new BehaviorSubject('');
  searchKeyword = '';
  filterParams: any = {};
  selectedSort: any = '';
  serverErrorFetch: string | null = null;
  rowsPerPage = 100;
  userType: string | null = '';

  get isPublicClaimsNoContractTab(): boolean {
    return this.router.url.includes('public-claims-no-contract');
  }

  get listTitle(): string {
    return this.isPublicClaimsNoContractTab
      ? 'Public Claims With No Contract'
      : 'Claim List';
  }

  isLegalClaim(claim: any): boolean {
    const legalFlag = claim?.is_legal_claim;

    if (legalFlag !== null && legalFlag !== undefined) {
      return legalFlag === true || legalFlag === 1 || legalFlag === '1';
    }

    // Some paginated responses currently omit the row flag even when the API
    // has already restricted the result set to legal claims.
    return (
      String(
        this.activatedRoute.snapshot.queryParamMap.get(
          'filter_by_is_legal_claim'
        )
      ) === '1'
    );
  }

  isExceptionClaim(claim: any): boolean {
    const exceptionFlag = claim?.is_exception;

    if (exceptionFlag !== null && exceptionFlag !== undefined) {
      return (
        exceptionFlag === true || exceptionFlag === 1 || exceptionFlag === '1'
      );
    }

    return (
      String(
        this.activatedRoute.snapshot.queryParamMap.get('filter_by_exception')
      ) === 'true'
    );
  }

  constructor(
    private router: Router,
    private _api: HttpService,
    private errHandle: ErrorHandlingService,
    private activatedRoute: ActivatedRoute,
    private claimApiService: ClaimApiService,
    private _authService: AuthService
  ) {}

  claimAdjustorFilter: Auto_Complete = new Auto_Complete(
    this._api,
    this.errHandle,
    `/${API_VERSIONS.USERS}/users`,
    true,
    undefined,
    true
  );
  repairFacilityFilter: Auto_Complete = new Auto_Complete(
    this._api,
    this.errHandle,
    `/${API_VERSIONS.THIRD_PARTIES}/third-parties`,
    true
  );
  serviceAdvisorFilter: Auto_Complete = new Auto_Complete(
    this._api,
    this.errHandle,
    `/${API_VERSIONS.THIRD_PARTIES}/third-parties`,
    true
  );
  claimAllUsersFilter: Auto_Complete = new Auto_Complete(
    this._api,
    this.errHandle,
    `/${API_VERSIONS.USERS}/users`,
    true
  );
  dealersFilter: Auto_Complete = new Auto_Complete(
    this._api,
    this.errHandle,
    `/${API_VERSIONS.USERS}/users`,
    true
  );
  dealerGroupsFilter: Auto_Complete = new Auto_Complete(
    this._api,
    this.errHandle,
    `/${API_VERSIONS.USERS}/users?filter_by_group=${UsersGroup.DealerGroups}`,
    true
  );
  brokersFilter: Auto_Complete = new Auto_Complete(
    this._api,
    this.errHandle,
    `/${API_VERSIONS.USERS}/users`,
    true
  );
  agentsFilter: Auto_Complete = new Auto_Complete(
    this._api,
    this.errHandle,
    `/${API_VERSIONS.USERS}/users`,
    true
  );

  ngOnInit(): void {
    this.pinPublicNoContractFilterIfNeeded();
    this.subscribeOnProductCategoryChange();
    this.subscribeOnUrlParamsChange();
    this.setFilterOptions();
    this.userType = this._authService.getUserType();
    if (this.userType == 'Agents') {
      this.filterOptions = this.filterOptions.filter(
        (option) =>
          [
            'filter_by_agents',
            'filter_by_brokers',
            'filter_by_updated_by',
            'filter_by_creation_date',
            'filter_by_last_status_change_date',
            'filter_by_created_by',
          ].indexOf(option.key) < 0
      );
    }
    this.claimAdjustorFilter.options = { filter_by_group: 10 };
    this.claimAdjustorFilter.searchBy = 'search';
    this.repairFacilityFilter.options = { filter_by_type: 6 };
    this.repairFacilityFilter.searchBy = 'global_search';
    this.serviceAdvisorFilter.options = { filter_by_type: 7 };
    this.serviceAdvisorFilter.searchBy = 'global_search';
    this.claimAllUsersFilter.successCallback =
      this.getClaimAllUsersSuccessCallBack.bind(this);
    this.claimAllUsersFilter.searchBy = 'search';
    this.dealersFilter.options = { filter_by_group: 5 };
    this.dealersFilter.searchBy = 'search';
    this.dealersFilter.successCallback =
      this.getDealersSuccessCallBack.bind(this);
    this.brokersFilter.options = { filter_by_group: 3 };
    this.brokersFilter.searchBy = 'search';
    this.brokersFilter.successCallback =
      this.getBrokersSuccessCallBack.bind(this);
    this.agentsFilter.options = { filter_by_group: 2 };
    this.agentsFilter.searchBy = 'search';
    this.agentsFilter.successCallback =
      this.getAgentsSuccessCallBack.bind(this);
    this.initPerPagesOptions();
    this.getListOfClaims();
    this.sorts = [
      { name: 'Default', key: 'Newest Created First' },
      {
        name: 'Alphabetical Order Increasing',
        key: 'Alphabetical Order Increasing',
      },
      {
        name: 'Alphabetical Order Decreasing',
        key: 'Alphabetical Order Decreasing',
      },
      { name: 'Newest Created First', key: 'Newest Created First' },
      { name: 'Oldest Created First', key: 'Oldest Created First' },
      { name: 'Newest Edited', key: 'Newest Edited' },
      { name: 'Latest Edited', key: 'Oldest Edited' },
    ];
    this.getClaimStatusList();
    this.getPrefixes();
    this.getCustomerStates();
    // this.getRefreshRate();
    // this._api.getReq('/groups').subscribe()
  }

  setFilterOptions() {
    if (this.isDealerView) {
      this.filterOptions = CLAIM_FILTER_OPTIONS_FOR_DEALER;
      return;
    }
    if (this.isBrokerView) {
      this.filterOptions = CLAIM_FILTER_OPTIONS_FOR_BROKER;
      return;
    }
    if (this.isManagementView) {
      this.filterOptions = CLAIM_FILTER_OPTIONS_FOR_MANAGEMENT;
      return;
    }
    this.filterOptions = CLAIM_FILTER_OPTIONS;
    this.excludePinnedPublicNoContractFilter();
  }

  private pinPublicNoContractFilterIfNeeded(): void {
    if (!this.isPublicClaimsNoContractTab) {
      return;
    }
    this.basicParams = {
      ...this.basicParams,
      filter_by_public_no_contract: 1,
    };
  }

  private excludePinnedPublicNoContractFilter(): void {
    if (!this.isPublicClaimsNoContractTab) {
      return;
    }
    this.filterOptions = this.filterOptions.filter(
      (option) => option.key !== 'filter_by_public_no_contract'
    );
  }

  private subscribeOnProductCategoryChange(): void {
    this.activatedRoute.queryParams
      .pipe(map((params) => params['filter_by_product_categories']))
      .subscribe((value) => {
        this.tableFilterBar?.filterForm
          ?.get('filter_by_product_categories')
          ?.setValue(value);
      });
  }

  private subscribeOnUrlParamsChange(): void {
    this.activatedRoute.queryParams
      .pipe(untilDestroyed(this))
      .subscribe((params) => {
        setTimeout(() => {
          if (this.tableFilterBar?.filterForm) {
            if (params['filter_by_dealers']) {
              this.tableFilterBar.filterForm
                .get('filter_by_dealers')
                ?.setValue(params['filter_by_dealers']);
            }
          }
        }, 1000);
      });
  }

  private initPerPagesOptions(): void {
    const increment = 15;
    const startAmount = 5;
    const maxAmount = 200;

    this.perPages = Array.from(
      { length: Math.floor((maxAmount - startAmount) / increment) + 1 },
      (_item, index) => {
        const amount = startAmount + index * increment;
        return { number: `${amount}`, key: amount };
      }
    );
  }

  getListOfClaims() {
    const isMyClaims: boolean = this.router.url.includes('my-claim-list');

    this.activatedRoute.queryParams
      .pipe(
        untilDestroyed(this),
        switchMap((params: Params) => {
          this.isLoading = true;
          console.log('DEBUG: getListOfClaims queryParams', params);
          let requestParams: any = {
            length: this.rowsPerPage,
            sort: 'Newest Created First',
            ...params,
            ...this.basicParams,
          };
          if (this.vehicleId) {
            requestParams['filter_by_vehicle'] = this.vehicleId;
          }
          if (isMyClaims) {
            requestParams['filter_by_adjustor'] =
              this._authService.getUserObj().id;
          }
          if (this.isPublicClaimsNoContractTab) {
            requestParams['filter_by_public_no_contract'] = 1;
          }
          if (this.isManagementView) {
            requestParams['is_claims_for_management'] = 1;
          }

          console.log('DEBUG: claimApiService.getAllPaginated requestParams', requestParams);
          return this.claimApiService.getAllPaginated(requestParams);
        })
      )
      .subscribe({
        next: (response: ApiResponse) => {
          this.isLoading = false;
          response.data.map((claim: any) => {
            claim.isOlderThan60Days =
              new Date().getTime() - new Date(claim.created_at).getTime() >
              60 * 24 * 60 * 60 * 1000;
            claim.isOlderThan30Days =
              new Date().getTime() - new Date(claim.created_at).getTime() >
              30 * 24 * 60 * 60 * 1000;
            return claim;
          });
          this.repeatClaimRow = response.data;
          this.totalItems = response.meta?.total ?? 0;
        },
        error: () => (this.isLoading = false),
      });
  }
  successCallBackForGetVehicle(res: any) {
    this.repeatClaimRow = res?.data;
    this.totalItems = res?.meta?.total || 0;
    this.pageSize = res?.meta?.per_page || 0;
    this.currentPage = res?.meta?.current_page || 0;
    this.isLoading = false;
    this.serverErrorFetch = null;
  }
  errCallbackForGetVehicle(err: any) {
    // use error handling service
    this.serverErrorFetch =
      err?.error?.message || 'Something wrong happened, please try again later';
    this.isLoading = false;
  }

  // search handling
  search() {
    this.filterParams['page'] = 1;
    this.searchInput.next(this.searchKeyword);
    this.searchInput.pipe(debounceTime(1000)).subscribe((value: String) => {
      if (this.searchKeyword.length > 2 || this.searchKeyword.length == 0) {
        if (this.searchKeyword) {
          this.filterParams['search_value'] = this.searchKeyword;
        } else {
          delete this.filterParams['search_value'];
        }
        this.router
          .navigate([], {
            queryParams: {
              page: 1,
              search_value: this.searchKeyword,
              search_category: this.selectCategory.key,
            },
          })
          .then(() => {
            window.scrollTo({ top: window.scrollY, behavior: 'smooth' });
          });
      }
    });
  }

  getClaimStatusList() {
    this.isClaimStatusLoading = true;
    this.filterOptions[0].isLoading = true;
    this._api
      .getReq(`/claim-status`)
      .pipe(
        take(1),
        finalize(() => (this.filterOptions[0].isLoading = false))
      )
      .subscribe(
        (res) => {
          this.filterOptions[0].options = res.data;
          this.isClaimStatusLoading = false;
        },
        (err) => {
          this.errHandle.errorHandling(err);
          this.isClaimStatusLoading = false;
        }
      );
  }

  getClaimAdjustorSuccessCallBack(res: any) {
    this.claimAdjustor = [];
    if (res?.data) {
      res?.data?.forEach((data: any) => {
        this.claimAdjustor.push({
          name: data?.first_name + ' ' + data?.last_name,
          id: data?.id,
        });
      });
    }
    return this.claimAdjustor;
  }
  getDealersSuccessCallBack(res: any) {
    this.dealers = [];
    if (res?.data) {
      res?.data?.forEach((data: any) => {
        this.dealers.push({
          name: data?.first_name + ' ' + data?.last_name,
          id: data?.id,
        });
      });
    }
    return this.dealers;
  }
  getBrokersSuccessCallBack(res: any) {
    this.brokers = [];
    if (res?.data) {
      res?.data?.forEach((data: any) => {
        this.brokers.push({
          name: data?.first_name + ' ' + data?.last_name,
          id: data?.id,
        });
      });
    }
    return this.brokers;
  }
  getAgentsSuccessCallBack(res: any) {
    this.agents = [];
    if (res?.data) {
      res?.data?.forEach((data: any) => {
        this.agents.push({
          name: data?.first_name + ' ' + data?.last_name,
          id: data?.id,
        });
      });
    }
    return this.agents;
  }

  getClaimAllUsersSuccessCallBack(res: any) {
    this.createdBy = [];
    this.updatedBy = [];
    if (res?.data) {
      res?.data?.forEach((data: any) => {
        this.createdBy.push({
          name: data?.first_name + ' ' + data?.last_name,
          id: data?.id,
        });
        this.updatedBy.push({
          name: data?.first_name + ' ' + data?.last_name,
          id: data?.id,
        });
      });
    }
    return this.createdBy, this.updatedBy;
  }

  stopProp(event: any) {
    event.stopPropagation();
  }

  copyClaimNumber(claimNumber: string, event: Event, message?: HTMLElement): void {
    event.stopPropagation();

    if (!claimNumber) {
      return;
    }

    navigator.clipboard.writeText(claimNumber);

    if (message) {
      message.style.opacity = '1';
      setTimeout(() => {
        message.style.opacity = '0';
      }, 500);
    }
  }

  toString(arr: any) {
    if (arr) {
      let products: any[] = [];
      arr?.forEach((data: any, index: number) => {
        products.push(`${data.label}${index < arr.length - 1 ? ', ' : ''}`);
      });
      return products;
    }
    return '';
  }

  claimDetails(id: number) {
    this.router.navigate([`/dashboard/claims/claim-details/${id}`]);
  }

  ngOnDestroy() {
    if (this.mySubscription) {
      this.mySubscription.unsubscribe();
    }
    // if (this.interval) {
    //   clearInterval(this.interval);
    // }
  }

  private getPrefixes(): void {
    this.claimApiService
      .getPrefixes()
      .pipe(take(1))
      .subscribe((result: ApiResponse) => {
        const filter = this.filterOptions.find(
          (option) => option.key === 'filter_by_claims_prefix'
        );
        if (filter) {
          filter.options = result.data.map(
            (prefix: { id: number; title: string }) => ({
              id: prefix.id,
              name: prefix.title,
            })
          );
        }
      });
  }

  private getCustomerStates(): void {
    const filter = this.filterOptions.find(
      (option) => option.key === 'filter_by_customer_state'
    );
    if (!filter) {
      return;
    }

    filter.isLoading = true;
    this.claimApiService
      .getCustomerStates()
      .pipe(
        take(1),
        finalize(() => (filter.isLoading = false))
      )
      .subscribe({
        next: (result: ApiResponse) => {
          filter.options = (result.data || []).map(
            (state: { value: string; label: string }) => ({
              id: state.value,
              name: state.label,
            })
          );
        },
        error: (error) => this.errHandle.errorHandling(error),
      });
  }
}
